import './ContactSection.css';

const checkIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 8.5L6 12L13.5 4.5" stroke="#99FE00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const sendIcon = (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 7.5H12.5" stroke="white" strokeWidth="1.5625" strokeLinecap="round"/>
    <path d="M8.125 3.125L12.5 7.5L8.125 11.875" stroke="white" strokeWidth="1.5625" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const formIcon = (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.66675 3.66602H18.3334V14.666H4.76675L3.66675 16.316V3.66602Z" stroke="white" strokeWidth="1.83333" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const listItems = [
  'A written scope and an indicative price',
  'Sandbox keys once vetting is done',
  'A named integration contact on chat',
];

export default function ContactSection() {
  return (
    <section className="contact" id="contact" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/contact-bg.jpg)` }}>
      <div className="contact__inner">
        <div className="contact__left">
          <div className="contact__glow" />
          <div className="contact__left-content">
            <div className="contact__top">
              <span className="contact__eyebrow">Get started</span>
              <h2 className="contact__heading">Let's talk about your payouts</h2>
              <p className="contact__para">Book a discovery call or send us a message. We'll get back to you within one business day.</p>
            </div>
            <div className="contact__bottom">
              <p className="contact__bottom-para">30 minutes to map your payout flows. It is a working conversation about your stack, volume and timeline, not a sales pitch.</p>
              <ul className="contact__list">
                {listItems.map((item, i) => (
                  <li key={i} className="contact__list-item">
                    <span className="contact__list-icon">{checkIcon}</span>
                    <span className="contact__list-text">{item}</span>
                  </li>
                ))}
              </ul>
              <div className="contact__links">
                <a href="tel:+919205554745" className="contact__link">
                  <span className="contact__link-label">Call us at</span>
                  <span className="contact__link-value">+91 92055 54745</span>
                </a>
                <a href="mailto:hello@settlor.money" className="contact__link">
                  <span className="contact__link-label">Email us</span>
                  <span className="contact__link-value">hello@settlor.money</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="contact__form-card">
          <div className="contact__form-icon-wrap">
            <span className="contact__form-icon">{formIcon}</span>
          </div>
          <h2 className="contact__form-heading">Schedule a discovery call</h2>
          <p className="contact__form-para">Tell us about your goals, and we'll tailor our expertise to fit your needs. Fill out the form and we'll get back to you soon.</p>
          <div className="contact__fields">
            <div className="contact__field">
              <label className="contact__label">Name</label>
              <input className="contact__input" type="text" placeholder="Shristy Bhadani" />
            </div>
            <div className="contact__row">
              <div className="contact__field">
                <label className="contact__label">Phone</label>
                <input className="contact__input" type="tel" placeholder="+91 98765 43210" />
              </div>
              <div className="contact__field">
                <label className="contact__label">Business Email</label>
                <input className="contact__input" type="email" placeholder="shristy@yourcompany.in" />
              </div>
            </div>
            <div className="contact__row">
              <div className="contact__field">
                <label className="contact__label">Company name</label>
                <input className="contact__input" type="text" placeholder="Your company" />
              </div>
              <div className="contact__field">
                <label className="contact__label">Industry</label>
                <select className="contact__select" defaultValue="" required>
                  <option value="">Select industry</option>
                  <option value="lending">Lending &amp; NBFCs</option>
                  <option value="insurance">Insurance</option>
                  <option value="ecommerce">E-commerce &amp; Marketplaces</option>
                  <option value="logistics">Logistics &amp; Delivery</option>
                  <option value="gaming">Media</option>
                  <option value="enterprise">Enterprise &amp; Payroll</option>
                </select>
              </div>
            </div>
            <div className="contact__field">
              <label className="contact__label">Message</label>
              <textarea className="contact__textarea" placeholder="Tell us about your stack, volume and timeline…" />
            </div>
          </div>
          <p className="contact__disclaimer">We'll only use your info to respond to your enquiry.</p>
          <button type="button" className="contact__submit">
            Send message
            <span className="contact__submit-icon">{sendIcon}</span>
          </button>
        </div>
      </div>
    </section>
  );
}
